import { Navigate, Outlet, useRoutes } from "react-router-dom"
import { HomePage } from "./pages/Home"
import { Box, LinearProgress } from "@mui/material";
import { ErrorLoginPage } from "./componente/Error/ErrorLogin";
import { NotFoundPage } from "./componente/Error/ErrorNotFound";
import { useAppSelector } from "./redux/hooks";
import { HistorialPage } from "./pages/General/historial";
import ScrollToTop from "./common/ScrollToTop";
import { SinAccesoPage } from "./componente/Error/SinAcceso";
import { TestPage } from "./pages/Test";
import { BandejaRevisorPage } from "./pages/Revisor/bandejacomunicados";
import { ConfigPage } from "./pages/Config";
import { useEffect } from "react";
import { outUser } from "./redux/slices/auth.slice";
import { AdminPage } from "./pages/Admin";
import { AprobarPage } from "./pages/Revisor/aprobacion";
import { useDispatch } from "react-redux";
import { AddAnuncioPage } from "./pages/Creador/AddAnuncioPage";
import { MisComunicadosPage } from "./pages/Creador/MisComunicadosPage";
import { EditAnuncioPage } from "./pages/Creador/EditAnuncioPage";
import { VerAnuncioPage } from "./pages/Home/VerAnuncio";
import { HistorialEstadoPage } from "./pages/Revisor/historialEstado";
import { HistorialEstadoPage as HistorialCreador} from "./pages/Creador/historialEstado";
import { PlantillasPage } from "./pages/Plantillas";
import { CampaniasPage } from "./pages/Campanias";
import { UserPage } from "./pages/User";
import { LayoutNotAuth } from "./common/Layout/LayoutNoAuth";
import { LayoutAuth } from "./common/Layout/LayoutAuth";
import { GeneralPage } from "./pages/General";
import { RevisorPage } from "./pages/Revisor";

const renderFallback = (
    <Box display="flex" alignItems="center" justifyContent="center" flex="1 1 auto">
        <LinearProgress
            sx={{
                width: 1,
                maxWidth: 320,
            }}
        />
    </Box>
);

export function AppRouter() {
    const { isAuth, userData } = useAppSelector((state) => state.authReducer);
    const dispatch = useDispatch();

    useEffect(() => {
        if (!userData || !userData.expiration) return;
    
        const checkTokenValidity = () => {
          const expirationTime = Date.parse(userData.expiration); // Convierte la expiración a timestamp
          const currentTime = Date.now();
          if (currentTime >= expirationTime) {
            dispatch(outUser()); // Cierra sesión automáticamente
          }
        };
    
        // Revisa el token inmediatamente y luego cada 30 minutos
        checkTokenValidity();
        const intervalId = setInterval(checkTokenValidity, 1800000); // 30 minutos
    
        // Limpia el intervalo al desmontar el componente
        return () => clearInterval(intervalId);
      }, [dispatch, userData]);

    const routes = useRoutes([
        {
            path: '/',
            element: (
                <LayoutNotAuth>
                    <Outlet />
                </LayoutNotAuth>
            ),
            children:[
                { index: true, element: <HomePage /> },
                { path: 'ver-anuncio/:id', element: <VerAnuncioPage /> },
                { path: 'plantillas', element: <PlantillasPage />},
                { path: 'campanias', element: <CampaniasPage />},
            ]
        },
        {
            path: '/general',
            element: 
                <LayoutAuth isAuth userRoles={userData.roles}>
                    <Outlet />
                </LayoutAuth>,
            children: [
                { index: true, element: <GeneralPage /> },
                { path: 'historial', element: <HistorialPage /> }
            ]
        },
        {
            path: '/admin',
            element: isAuth && userData.roles.find(r => r === 'Administrador') ? (
                <LayoutAuth isAuth userRoles={userData.roles}>
                    <Outlet />
                </LayoutAuth>
            ) : (
                <Navigate to="/" replace />
            ),
            children: [
                { index: true, element: <AdminPage /> },
                { path: 'test', element: <TestPage /> }
            ]
        },
        {
            path: '/reviewer',
            element: isAuth && userData.roles.find(r => r === 'Revisor') ? (
                <LayoutAuth isAuth userRoles={userData.roles}>
                    <Outlet />
                </LayoutAuth>
            ) : (
                <Navigate to="/" replace />
            ),
            children: [
                { index: true, element: <RevisorPage /> },
                { path: 'aprobacion', element: <BandejaRevisorPage /> },
                { path: 'ver-aprobacion/:id', element: <AprobarPage />},
                { path: 'ver-historial/:id', element: <HistorialEstadoPage />},
                { path: 'config', element: <ConfigPage />},
                { path: 'plantillas', element: <PlantillasPage />},
                { path: 'campanias', element: <CampaniasPage />},
            ]
        },
        // {
        //     path: '/config',
        //     element: isAuth && userData.roles.find(r => r === 'Revisor') ? (
        //         <LayoutAuth isAuth userRoles={userData.roles}>
        //             <Outlet />
        //         </LayoutAuth>
        //     ) : (
        //         <Navigate to="/" replace />
        //     ),
        //     children: [
        //         { index: true, element: <ConfigPage /> },
        //     ]
        // },
        {
            path: '/creator',
            element: isAuth && userData.roles.find(r => r === 'Creador') ? (
                <LayoutAuth isAuth userRoles={userData.roles}>
                    <Outlet />
                </LayoutAuth>
            ) : (
                <Navigate to="/" replace />
            ),
            children:[
                {index: true, element: <HomePage/>},
                {path: 'addAnuncio',element: <AddAnuncioPage />},
                {path: 'editAnuncio/:id', element: <EditAnuncioPage />},
                {path: 'misComunicados',element: <MisComunicadosPage />},
                {path: 'ver-historial/:id', element: <HistorialCreador />}
            ]
        },
        {
            path: '/perfil',
            element: isAuth ? (
                <LayoutAuth isAuth userRoles={userData.roles}>
                    <Outlet />
                </LayoutAuth>
            ) : (
                <Navigate to="/" replace />
            ),
            children: [
                { index: true, element: <UserPage /> },
            ]
        },
        {
            path: '/noLogin',
            element: (
                <ErrorLoginPage />
            )
        },
        {
            path: '/401',
            element: (
                <SinAccesoPage />
            )
        },
        {
            path: '*',
            element: (
                <NotFoundPage />
            )
        }
    ]);

    return (
        <>
            <ScrollToTop />
            {routes}
        </>
    );
}